var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page formPage" }, [
    _c("div", { staticClass: "page-content" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-10 offset-md-1" },
              [
                _c("back-button"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "panel21 panel-default" },
                  [
                    _c("div", { staticClass: "panel-heading" }, [
                      _c(
                        "div",
                        { staticClass: "showLargeScreenOnly formTitleBlock" },
                        [
                          _c(
                            "h4",
                            {
                              staticClass: "content-block labelAccordionForm",
                              style: { color: _vm.titleColor },
                            },
                            [
                              _vm.icon == "out"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/inbox_out.png"),
                                    },
                                  })
                                : _vm.icon == "in"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/inbox_into.png"),
                                    },
                                  })
                                : _vm.icon == "verif"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/icon_identite_black.png"),
                                    },
                                  })
                                : _vm.icon == "devis"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/sales_quotation.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.formTitle) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "showSmallScreenOnly formTitleBlock" },
                        [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "content-block labelAccordionForm creationFormTitle",
                              style: { color: _vm.titleColor },
                            },
                            [
                              _vm.icon === "out"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/inbox_out.png"),
                                    },
                                  })
                                : _vm.icon === "in"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/inbox_into.png"),
                                    },
                                  })
                                : _vm.icon === "verif"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/icon_identite_black.png"),
                                    },
                                  })
                                : _vm.icon == "devis"
                                ? _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../assets/static/images/icons/sales_quotation.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.formTitle) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.writable
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "content-block italicMandatoryIndication",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("common.asterisk_obligation_label")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm._t("formcontent"),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("under-panel"),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._t("footerbuttons"),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "80px" } }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }